<template>
  <b-overlay
    :show="show"
    variant="transparent"
    opacity="0.99"
    blur="5px"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <b-icon-controller
          font-scale="3"
          animation="cylon"
        />
        <p id="cancel-label">
          กรุณารอสักครู่...
        </p>
      </div>
    </template>
    <b-card
      no-body
    >
      <b-card-body>

        <div class="row">
          <div class="col-md-3">
            <div class="row">
              <div class="col-md-6">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  block
                  @click="getwinloss('Today')"
                >
                  วันนี้
                </b-button>
              </div>
              <div class="col-md-6 mb-1">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  block
                  @click="getwinloss('Yesterday')"
                >
                  เมื่อวาน
                </b-button>
              </div>
              <div class="col-md-6 mb-1">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  block
                  @click="getwinloss('ThisWeek')"
                >
                  อาทิตย์นี้
                </b-button>
              </div>
              <div class="col-md-6 mb-1">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  block
                  @click="getwinloss('LastWeek')"
                >
                  อาทิตย์ที่แล้ว
                </b-button>
              </div>
              <div class="col-md-6 mb-1">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  block
                  @click="getwinloss('ThisMonth')"
                >
                  เดือนนี้
                </b-button>
              </div>
              <div class="col-md-6 mb-1">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  block
                  @click="getwinloss('LastMonth')"
                >
                  เดือนที่แล้ว
                </b-button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">

                <b-form-group>
                  <flat-pickr
                    v-model="rangeDate"
                    placeholder="เลือกวันที่"
                    class="form-control"
                    :config="{
                      mode: 'range',
                      enableTime: true,
                      dateFormat: 'Y-m-d',
                      time_24hr: true,
                      defaultHour: 0,
                    }"
                  />
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="btn-icon"
                  block
                  @click="RangDateCal()"
                >
                  <feather-icon icon="SearchIcon" />
                  Search
                </b-button>
              </div>
            </div>
          </div>
          <div class="col-md-9">
            <b-form-group
              class="mr-1 mb-md-0"
            >

              <b-form-checkbox
                v-model="allSelected"
                :indeterminate="indeterminate"
                aria-describedby="flavours"
                aria-controls="flavours"
                @change="toggleAll"
              >
                ทั้งหมด
              </b-form-checkbox>
              <b-form-checkbox-group
                id="checkbox-group-1"
                v-model="selected"
                :options="options"
                value-field="name"
                text-field="name"
                name="flavour-1"
                class="demo-inline-spacing"
                @change="getwinloss()"
              />
            </b-form-group>
          </div>
        </div>

      </b-card-body>

      <div style="overflow-x:auto;">
        <table
          id="zero_config"
          class="table table-bordered table-sm table-striped table-hover"
        >
          <thead>
            <tr class="text-center">
              <th
                rowspan="2"
                class="align-middle"
              >
                #
              </th>
              <th
                rowspan="2"
                class="align-middle"
              >
                ยูสเอเย่นต์
              </th>
              <th
                rowspan="2"
                class="align-middle"
                style=""
              >
                ยอดแทงทั้งหมด
              </th>
              <th
                rowspan="2"
                class="align-middle"
                style="width: 5%;"
              >
                ส่วนลดทั้งหมด
              </th>
              <th
                rowspan="2"
                class="align-middle"
                style=""
              >
                จำนวนแทงทั้งหมด
              </th>
              <th
                colspan="3"
                class="align-middle bg-warning"
              >
                Agent
              </th>
              <th
                colspan="3"
                class="align-middle"
              >
                Company
              </th>
            </tr>
            <tr class="text-center">
              <th
                style=""
                class="bg-warning"
              >
                ยอดถูกรางวัล
              </th>
              <th
                style="width: 5%;"
                class="bg-warning"
              >
                ส่วนลด
              </th>
              <th
                style=""
                class="bg-warning"
              >
                รวม
              </th>
              <th style="">
                ยอดส่ง
              </th>
              <th style="width: 5%;">
                ส่วนลด
              </th>
              <th style="">
                รวม
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(data,index) in listdata"
              :key="data"
              class="text-center font-weight-bolder"
            >
              <td>{{ index + 1 }}</td>
              <th scope="row">
                <router-link
                  :to="{ name: 'manage-master-win-loss-detail', params: { id: data.agent_id } }"
                  style="color: blue"
                >
                  {{ data.username }}
                </router-link>
              </th>

              <td>
                {{ Commas(data.total_bet) }}
              </td>
              <td>
                {{ Commas(data.total_discount) }}
              </td>
              <td>
                {{ Commas(data.bet_length) }}
              </td>

              <td>
                {{ Commas(data.win_agent) }}
              </td>
              <td>
                {{ Commas(data.dis_agent) }}
              </td>
              <td
                v-if="data.total_agent < 0"
                style="color:red"
              >
                {{ Commas(data.total_agent) }}
              </td>
              <td
                v-else
              >
                {{ Commas(data.total_agent) }}
              </td>

              <td>
                {{ Commas(data.winloss_com) }}
              </td>
              <td>
                {{ Commas(data.dis_com) }}
              </td>
              <td>
                {{ Commas(data.total_com) }}
              </td>

            </tr>
          </tbody>
          <tfoot>
            <tr class="text-right font-weight-bold text-white">
              <td
                colspan="2"
                class="text-center"
              >
                ทั้งหมด
              </td>
              <td>
                <span
                  class="text-center font-weight-bolder"
                >
                  {{ Commas(listdata.reduce((total, item) => total + Number(item.total_bet), 0)) }}<span />
                </span>
              </td>
              <td>
                <span
                  class="text-center font-weight-bolder"
                >
                  {{ Commas(listdata.reduce((total, item) => total + Number(item.total_discount), 0)) }}<span />
                </span>
              </td>
              <td>
                <span
                  class="text-center font-weight-bolder"
                >
                  {{ Commas(listdata.reduce((total, item) => total + Number(item.bet_length), 0)) }}<span />
                </span>
              </td>
              <td>
                <span
                  class="text-center font-weight-bolder"
                >
                  {{ Commas(listdata.reduce((total, item) => total + Number(item.win_agent), 0)) }}<span />
                </span>
              </td>
              <td>
                <span
                  class="text-center font-weight-bolder"
                >
                  {{ Commas(listdata.reduce((total, item) => total + Number(item.dis_agent), 0)) }}<span />
                </span>
              </td>

              <td>
                <span
                  v-if="listdata.reduce((total, item) => total + Number(item.total_agent), 0) < 0"
                  class="text-center font-weight-bolder"
                  style="color:red"
                >
                  {{ Commas(listdata.reduce((total, item) => total + Number(item.total_agent), 0)) }}<span />
                </span>
                <span
                  v-else
                  class="text-center font-weight-bolder"
                >
                  {{ Commas(listdata.reduce((total, item) => total + Number(item.total_agent), 0)) }}<span />
                </span>
              </td>
              <td>
                <span
                  class="text-center font-weight-bolder"
                >
                  {{ Commas(listdata.reduce((total, item) => total + Number(item.winloss_com), 0)) }}<span />
                </span>
              </td>
              <td>
                <span
                  class="text-center font-weight-bolder"
                >
                  {{ Commas(listdata.reduce((total, item) => total + Number(item.dis_com), 0)) }}<span />
                </span>
              </td>
              <td>
                <span
                  class="text-center font-weight-bolder"
                >
                  {{ Commas(listdata.reduce((total, item) => total + Number(item.total_com), 0)) }}<span />
                </span>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0" />
      <b-modal
        id="modal-1"
        title="Add Class"
        ok-only
        ok-title="Save"
      >
        <b-form-group
          label="Class"
          label-for="vi-first-name"
        >
          <b-input-group class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon icon="CheckSquareIcon" />
            </b-input-group-prepend>
            <b-form-input
              id="vi-first-name"
              placeholder=""
            />
          </b-input-group>
        </b-form-group>
      </b-modal>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BFormCheckbox, BFormCheckboxGroup, BInputGroupPrepend, BModal, BCard,
  // BTable, BAvatar,
  BFormGroup,
  // BFormSelect, BPagination,
  BInputGroup, BFormInput,
  // BInputGroupAppend,
  BButton,
  BCardBody, VBToggle,
  BOverlay,
  BIconController,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
// import moment from 'moment-timezone'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BFormCheckbox,
    BFormCheckboxGroup,
    BInputGroupPrepend,
    BModal,
    BCard,
    // BTable,
    // BAvatar,
    BFormGroup,
    // BFormSelect,
    // BPagination,
    BInputGroup,
    BFormInput,
    // BInputGroupAppend,
    BButton,
    BCardBody,
    flatPickr,
    BOverlay,
    BIconController,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      show: true,
      rangeDate: null,
      days: null,
      twinloss: 0.00,
      twaiting: 0.00,
      tdiscount: 0.00,
      twitingdiscount: 0.00,
      selected: [],
      options: [],
      listdata: [],
      perPage: 10,
      pageOptions: [10, 15, 20],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      usersList: [],
      datasidebar: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      /* eslint-disable global-require */
      items: [],
      addNewDataSidebar: false,
      allSelected: false,
      indeterminate: false,
      start: null,
      end: null,
    }
  },
  watch: {
    selected(newValue) {
      if (newValue.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newValue.length === this.options.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }
    },
  },
  mounted() {
    this.GetData()
    // this.getwinloss()
  },
  methods: {
    RangDateCal() {
      // console.log(date)
      const rangArray = this.rangeDate.split(' to ')
      const start = rangArray[0]
      const end = rangArray[1]

      this.start = start
      this.end = end
      // console.log(this.start, this.end)
      // eslint-disable-next-line no-bitwise
      if (this.start && this.end) {
        this.getwinloss(null, this.start, this.end)
      }
    },
    wluser(username) {
      const paramss = {
        username,
        days: this.days,
        selected: this.selected,
      }
      this.$router.push('/win-loss-user')
      localStorage.setItem('wlParams', JSON.stringify(paramss))
    },
    toggleAll(checked) {
      this.selected = checked ? this.options.slice() : []
      this.getwinloss()
    },
    async GetData() {
      await this.$http
        .get('lottotype')
        .then(async response => {
          this.show = false
          // this.options = response.data
          // eslint-disable-next-line no-restricted-syntax
          for await (const da of response.data) {
            this.options.push(da.name)
          }
          // console.log(response.data)
        })
        .catch(error => console.log(error))
    },
    getwinloss(days = null, start = null, end = null) {
      this.show = true
      const obj = {
        selected: this.selected,
        days,
        start,
        end,
      }
      this.$http
        .post('history/showsubagent', obj)
        .then(response => {
          this.listdata = response.data
          this.show = false
        })
        .catch(error => {
          console.log(error)
          this.show = false
          this.listdata = []
        })
    },
    Commas(x) {
      if (!x) {
        return 0
      } if (x % 1 !== 0) {
        if (x % 1 < 0.01) {
          return Number(x).toFixed(3).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
        return Number(x).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  },
}
</script>

<style scoped>
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  border: 1px solid #ddd;
}
thead,
tfoot {
  background-color: gold;
  color: rgb(0, 0, 0);
  text-align: center;
}

tbody {
  background-color: #f1e8e8;
}
tr:nth-child(even) {
  background-color: #f2f2f2;
}

td,
th {
  border: 1px solid rgb(190, 190, 190);
  padding: 5px 10px;
}

td {
  text-align: center;
  color: #000;
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.form-item-section {
background-color:$product-details-bg;
}
</style>
